import { render } from "./ExcelStaff.vue?vue&type=template&id=de3c69d4"
import script from "./ExcelStaff.vue?vue&type=script&lang=js"
export * from "./ExcelStaff.vue?vue&type=script&lang=js"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__